import React from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";

const SOCIAL_ICON_OPTIONS = [
  "FaFacebookF",
  "FaInstagram",
  "FaXTwitter",
  "FaYoutube",
  "FaLinkedinIn",
  "FaTikTok",
];

const FooterSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleContactChange = (field, value) => {
    handleChange("contactInfo", {
      ...(data.contactInfo || {}),
      [field]: value,
    });
  };

  const handleOfficeChange = (field, value) => {
    handleChange("officeInfo", {
      ...(data.officeInfo || {}),
      [field]: value,
    });
  };

  const updateSocialLink = (index, updates) => {
    const socialLinks = [...(data.socialLinks || [])];
    socialLinks[index] = { ...socialLinks[index], ...updates };
    handleChange("socialLinks", socialLinks);
  };

  const addSocialLink = () => {
    handleChange("socialLinks", [
      ...(data.socialLinks || []),
      { icon: "FaFacebookF", link: "" },
    ]);
  };

  const removeSocialLink = (index) => {
    handleChange(
      "socialLinks",
      (data.socialLinks || []).filter((_, i) => i !== index)
    );
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Footer Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading || ""}
                  onChange={(e) => handleChange("heading", e.target.value)}
                  placeholder="Enter footer heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Paragraph</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={data.paragraph || ""}
                  onChange={(e) => handleChange("paragraph", e.target.value)}
                  placeholder="Enter footer paragraph"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={data.contactInfo?.email || ""}
                  onChange={(e) => handleContactChange("email", e.target.value)}
                  placeholder="info@tdcp.gop.pk"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  value={data.contactInfo?.phone || ""}
                  onChange={(e) => handleContactChange("phone", e.target.value)}
                  placeholder="051 3357066"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Office Address</Form.Label>
                <Form.Control
                  type="text"
                  value={data.officeInfo?.address || ""}
                  onChange={(e) =>
                    handleOfficeChange("address", e.target.value)
                  }
                  placeholder="Office address"
                />
              </Form.Group>
            </Col>
          </Row>

          <h6 className="fw-bold mb-3">Social Links</h6>
          {(data.socialLinks || []).map((social, index) => (
            <div
              key={index}
              className="border rounded p-3 mb-3 bg-light-subtle"
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Social Link {index + 1}</h6>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => removeSocialLink(index)}
                >
                  Remove
                </Button>
              </div>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Icon</Form.Label>
                    <Form.Select
                      value={social.icon || "FaFacebookF"}
                      onChange={(e) =>
                        updateSocialLink(index, { icon: e.target.value })
                      }
                    >
                      {SOCIAL_ICON_OPTIONS.map((icon) => (
                        <option key={icon} value={icon}>
                          {icon}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group className="mb-3">
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="url"
                      value={social.link || ""}
                      onChange={(e) =>
                        updateSocialLink(index, { link: e.target.value })
                      }
                      placeholder="https://"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addSocialLink}>
            Add Social Link
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default FooterSection;
